import React from "react";
import styles from "./Works.module.css";

const Works = () => {
  return (
    <div className={styles.works}>
      <div className={styles.worksContainer}>
        <h1
          className={styles.heading}
          data-aos="fade-down"
          data-aos-duration="500"
        >
          See Why Affiliates Choose PrepAI for Monthly Income
        </h1>
        <p
          style={{
            marginTop: "20px",
            fontWeight: "normal",
            fontSize: "20px",
            textAlign: "center",
          }}
        >
          Our affiliates love how easy it is to earn with PrepAI. Simply share
          our platform, watch your commissions roll in, and enjoy a steady
          income stream.
        </p>
        <br />
        <div className={styles.wrapper}>
          <div
            className={styles.card1}
            data-aos="flip-left"
            data-aos-duration="500"
            data-aos-delay="400"
          >
            <div>
              <h2>Become the face of ed-tech</h2>
            </div>
            <div style={{ fontSize: "15px" }}>
              Help thousands educate, learn smarter, and get recognized as a top
              partner in the booming ed-tech space.
            </div>
          </div>
          <div
            className={styles.card2}
            data-aos="flip-left"
            data-aos-duration="500"
            data-aos-delay="400"
          >
            <div>
              <h2>High Referral Bonus</h2>
            </div>
            <div style={{ fontSize: "15px" }}>
              Get up to <strong>$300 extra</strong> in your first month and{" "}
              <strong>$400 every month</strong> after. The more you share, the
              more you earn.
            </div>
          </div>
          <div
            className={styles.card3}
            data-aos="flip-left"
            data-aos-duration="500"
            data-aos-delay="400"
          >
            <div>
              <h2>Stable Income Source</h2>
            </div>
            <div style={{ fontSize: "15px" }}>
              Use your network as a steady paycheck.{" "}
              <strong>Monthly bonuses plus earnings up to $3000+</strong> mean
              your income can grow as fast as you do.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.wrapperleft}>
        <div
          className={styles.card1}
          data-aos="flip-left"
          data-aos-duration="500"
          data-aos-delay="400"
        >
          <div>
            <h2>24x7 Affiliate Aid</h2>
          </div>
          <div style={{ fontSize: "15px" }}>
            Need help? We're here day or night to guide you, answer questions,
            and multiply your earnings, because your success is our priority.
          </div>
        </div>
        <div
          className={styles.card1}
          data-aos="flip-left"
          data-aos-duration="500"
          data-aos-delay="400"
        >
          <div>
            <h2>Transparent Commission Structure</h2>
          </div>
          <div style={{ fontSize: "15px" }}>
            Clear, simple, and upfront, know exactly what you earn with every
            referral, no hidden terms, and automatic bonuses added to your
            payouts.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Works;
